export default __webpack_public_path__ + "static/media/42_desktop.917be1ae.jpg";